import { ColumnFilter, TotalRowConfig } from "../bootgridTypes";

export interface ViewManagerView {
    Id: string;
    UserId: string;
    Name: string;
    DisplayName: string;
    IsDefault: boolean;
    IsVisible: boolean;
    IsPrivate: boolean;
    IsActive: boolean;
    ButtonVisibilities: ButtonVisibilities;
}
export interface ButtonVisibilities {
    ShowEditButton: boolean;
    ShowSaveButton: boolean;
    ShowDeleteButton: boolean;
    ShowAddButton: boolean;
    ShowShareButton: boolean;
}
export type RecordPageView = {
    Id: string;
    UserId: string;
    ParentName: string;
    Name: string;
    IsPrivate: boolean;
    BootgridViews: Record<string, string>;
};
export type GridView = {
    Id: string;
    UserId: string;
    ParentName: string;
    Name: string;
    IsPrivate: boolean;
    BootgridState: BootgridState;
};
export type BootgridState = {
    BootgridId: string;
    SelectedGridViewId: string;
    IsAdvancedSearchCollapsed: boolean;
    IsColumnSearchCollapsed: boolean;
    RowDisplayCount: number;
    SelectedSubTableId: string;
    VisibleColumnIds: string[];
    SortColumn: SortColumn;
    ColumnSearches: ColumnSearch[];
    AdvancedFilters: ColumnFilter[];
    SelectedRowId: string;
    CurrentPage: number;
    TotalRowConfig?: TotalRowConfig;
};
export enum BootgridViewType {
    Record = "Record",
    Grid = "Grid",
}
export type SortColumn = {
    ColumnDataId: string;
    SortDirection: "asc" | "desc" | "";
};
export type ColumnSearch = {
    ColumnDataId: string;
    SearchValue: string;
};
export interface Response<T> {
    data: T;
    message: string;
}